import type { KgInsightThemeType } from '@api';
import type { ChipFilteredData } from '@terminal/components/search-modal/utils';

export const entityTabs = [
  'stocks',
  'etfs',
  'indexes',
  'fx',
  'commodities',
  'govBonds',
];

export const THEME_TYPE_CHIPS = [
  'industry',
  'financial',
  'macro',
] as const satisfies readonly KgInsightThemeType[];

const THEME_TYPE_CHIP_SET: ReadonlySet<string> = new Set(THEME_TYPE_CHIPS);

const THEME_TYPE_CHIP_I18N_KEYS = {
  industry: 'widget:graphExplore.search.tabs_industry',
  financial: 'widget:graphExplore.search.tabs_financial',
  macro: 'widget:graphExplore.search.tabs_macro',
} as const;

export const isThemeTypeChip = (
  chip: string
): chip is (typeof THEME_TYPE_CHIPS)[number] => THEME_TYPE_CHIP_SET.has(chip);

export const isThemesChip = (chip: string) =>
  chip === 'themes' || isThemeTypeChip(chip);

export const getThemeTypesForChip = (
  chip: string
): KgInsightThemeType[] | undefined =>
  isThemeTypeChip(chip) ? [chip] : undefined;

export const getSearchAssetChipCategories = (
  categories: ChipFilteredData[],
  isNewThemeSearchEnabled: boolean
): ChipFilteredData[] => {
  if (!isNewThemeSearchEnabled) {
    return categories;
  }

  return categories.flatMap(category => {
    if (category.value !== 'themes') {
      return [category];
    }

    return THEME_TYPE_CHIPS.map(themeType => ({
      name: THEME_TYPE_CHIP_I18N_KEYS[themeType],
      value: themeType,
      data: [],
    }));
  });
};

export const getVisibleSearchAssetChips = (
  categories: ChipFilteredData[],
  hasRecents: boolean
) => categories.slice(hasRecents ? 0 : 1);
